<template>
  <v-container fluid>
    <v-card>
      <v-dialog persistent v-model="dialog" max-width="800px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            style="float:right;margin-top:17px;margin-right:10px;"
            color="primary"
            dark
            class="mb-2"
            @click="borraObjetoUsuario()"
            v-bind="attrs"
            v-on="on"
            >Nuevo empleado</v-btn
          >
        </template>
        <modal-nuevo-usuario
          v-if="dialog"
          :usuarioPasadoModal="usuarioPasadoUsuarios"
          @insertarUsuario="insertarUsuariox($event)"
          @editarUsuario="editarUsuariox($event)"
          @cierraDialogo="cierraDialogox()"
        />
      </v-dialog>

      <v-card-title>
        Usuarios
        <v-spacer></v-spacer>
        <v-text-field
          outlined
          clearable
          dense
          v-model="search"
          append-icon="mdi-magnify"
          label="Búsqueda"
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-alert v-if="mostrarErrorCarga" outlined type="error">
        Hubo un problema cargando la información, revise su conexión a internet e intente
        nuevamente.
      </v-alert>
      <v-data-table
        :loading="tableLoading"
        loading-text="Cargando... por favor espere."
        :headers="headers"
        :items="this.usuariosL"
        :search="search"
      >
        <template #item.NOMBRECOMPLETO="{ item }">
          <span>{{ item.NOMBRE }} {{ item.APELLIDO_P }} {{ item.APELLIDO_M }}</span>
        </template>
        <template #item.ESTADO="{ item }">
          <span>{{ item.ESTADO }} </span>
        </template>
        <template #item.actions="{ item }">
          <v-btn color="blue" class="mr-2" text rounded dark @click="editItem(item)">
            Editar
            <v-icon small class="mr-2">
              mdi-pencil
            </v-icon>
          </v-btn>
          <v-btn color="red" rounded dark text @click="deleteItem(item)">
            Borrar
            <v-icon small class="mr-2">
              mdi-delete
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <v-snackbar
      v-model="snackbarExito"
      timeout="2000"
      rounded="pill"
      centered
      elevation="8"
      color="blue darken-1"
      ><span style="font-size:20px;">
        {{ mensajeSnackbarExito }} <v-icon medium> mdi-check-circle </v-icon>
      </span></v-snackbar
    >

    <ModalErrorEnAccion
      :mensajeError="mensajeErrorModalErrorEnAccion"
      :show="dialogErrorEnAccion"
      @cerrarModalEnAccion="dialogErrorEnAccion = false"
    />

    <modal-confirmar-eliminacion
      :show="dialogConfirmarEliminacion"
      @cerrarModalFraccion="dialogConfirmarEliminacion = false"
      @confirmarEliminacionFraccionA="confirmDeleteItem()"
    />
    <v-overlay :value="loaderUsuarios">
      <v-progress-circular indeterminate size="100"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalConfirmarEliminacion from "@/components/modales/ModalConfirmarEliminacion.vue";
import ModalErrorEnAccion from "@/components/modales/ModalErrorEnAccion.vue";
import ModalNuevoUsuario from "@/components/ModalNuevoUsuario.vue";

export default {
  name: "Usuarios",
  methods: {
    ...mapActions("usuarios", [
      "getUsuarios",
      "insertUsuarios",
      "deleteUsuarios",
      "deleteUsuarios",
      "destroyUserStore",
      "updateUsuarios"
    ]),
    async insertarUsuariox(user) {
      //   console.log(user);
      this.loaderUsuarios = true;
      const res = await this.insertUsuarios(user);
      if (res[0] == true) {
        this.snackbarExito = true;
        this.mensajeSnackbarExito = "Usuario insertado exitosamente";
        this.cierraDialogox();
      } else {
        this.mensajeErrorModalErrorEnAccion = res[1];
        this.dialogErrorEnAccion = true;
      }
      this.loaderUsuarios = false;
    },
    async editarUsuariox(user) {
      const res = await this.updateUsuarios(user);
      if (res[0] == true) {
        this.cierraDialogox();
        this.snackbarExito = true;
        this.mensajeSnackbarExito = "Usuario editado exitosamente";
      } else {
        this.mensajeErrorModalErrorEnAccion = res[1];
        this.dialogErrorEnAccion = true;
      }
    },
    cierraDialogox() {
      this.dialog = false;
    },
    borraObjetoUsuario() {
      this.usuarioPasadoUsuarios = {};
    },
    editItem(item) {
      this.usuarioPasadoUsuarios = item;
      this.dialog = true;
      // console.log(item);
    },
    async deleteItem(item) {
      this.dialogConfirmarEliminacion = true;
      this.idUsuarioEliminar = item.ID;
    },
    async confirmDeleteItem() {
      const res = await this.deleteUsuarios(this.idUsuarioEliminar);
      if (res[0] == true) {
        this.snackbarExito = true;
        this.mensajeSnackbarExito = "Usuario eliminado exitosamente";
      } else {
        this.mensajeErrorModalErrorEnAccion = res[1];
        this.dialogErrorEnAccion = true;
      }
      this.dialogConfirmarEliminacion = false;
    }
  },
  components: {
    ModalNuevoUsuario,
    ModalConfirmarEliminacion,
    ModalErrorEnAccion
  },
  computed: {
    ...mapState("usuarios", {
      usuariosL: state => state.listUsuarios
    })
  },
  async mounted() {
    this.tableLoading = true;
    const res = await this.getUsuarios();
    if (res[0]) {
      this.tableLoading = false;
    } else if (res[1] === "errorcarga") {
      this.mostrarErrorCarga = true;
    }
  },
  beforeDestroy() {
    this.destroyUserStore();
  },
  data: () => ({
    loaderUsuarios: false,
    mostrarErrorCarga: false,
    tableLoading: false,
    mensajeErrorModalErrorEnAccion: "",
    mensajeSnackbarExito: "",
    snackbarExito: false,
    dialogConfirmarEliminacion: false,
    dialogErrorEnAccion: false,
    // Terminan variables de modales
    dialog: false,
    dialogError: false,
    dialogConfirmDelete: false,
    dialogAccionExitosa: false,
    idUsuarioEliminar: 0,
    msgError: {},
    usuarioPasadoUsuarios: {},
    search: "",
    itemsRoles: [
      { rol: "ADMIN", ide: 1 },
      { rol: "EMPLEADO", ide: 2 }
    ],
    headers: [
      {
        text: "Email",
        align: "center",
        sortable: true,
        value: "EMAIL"
      },
      {
        text: "Usuario",
        align: "center",
        sortable: true,
        value: "USUARIO"
      },
      {
        text: "Nombre",
        align: "center",
        sortable: true,
        value: "NOMBRECOMPLETO"
      },
      {
        text: "Estado",
        align: "center",
        sortable: true,
        value: "ESTADO"
      },
      {
        text: "Rol",
        align: "center",
        sortable: true,
        value: "ROL"
      },
      {
        text: "Sucursal",
        align: "center",
        sortable: true,
        value: "SUCURSAL"
      },
      {
        text: "",
        align: "center",
        sortable: false,
        value: "actions"
      }
    ]
  })
};
</script>
